import { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

import { defaultFirebaseConfigurations } from '@/config/defaultFirebaseConfiguration.ts'
import { remoteConfigDefaultsForFirebase } from '@/config/utils'
import { FIREBASE_CONFIG } from '@/constants/Common'
import { getAnalytics, logEvent, setCurrentScreen } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'
import { fetchAndActivate, getRemoteConfig } from 'firebase/remote-config'

// eslint-disable-next-line react-refresh/only-export-components
export const app = initializeApp(FIREBASE_CONFIG)

export const firebaseConfiguration = getRemoteConfig(app)
firebaseConfiguration.defaultConfig = {
  ...remoteConfigDefaultsForFirebase,
  ...defaultFirebaseConfigurations,
}

firebaseConfiguration.settings = {
  minimumFetchIntervalMillis: 1000,
  fetchTimeoutMillis: 60000,
}

/** Singleton promise ensuring fetchAndActivate is called only once per app load. */
let activationPromise: Promise<boolean> | null = null
export function ensureConfigActivated(): Promise<boolean> {
  if (!activationPromise) {
    activationPromise = fetchAndActivate(firebaseConfiguration)
      .then(() => true)
      .catch((error) => {
        console.error('Firebase Remote Config: Failed to fetch and activate.', error)
        return false
      })
  }
  return activationPromise
}

const analytics = getAnalytics(app)

// eslint-disable-next-line react-refresh/only-export-components
export const useInitializeAnalytics = () => {
  useEffect(() => {
    ReactGA.initialize(import.meta.env.VITE_GA_ID || 'G-4CT01KQEJ7')
  }, [])
}

export const AutoPageViewComponent = () => {
  const location = useLocation()
  useEffect(() => {
    if (ReactGA.isInitialized) {
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search })
    }
    const pagePath = location.pathname + location.search
    setCurrentScreen(analytics, pagePath)
    logEvent(analytics, 'page_view', { page_path: pagePath })
  }, [location])
  return <></>
}
